import React from "react";
import styled from "styled-components";
import { Form } from 'antd';

const FormsWrapper = styled(Form)`
 .ant-form-item {
    margin-left: 0 !important;
    margin-right: 0 !important;
    display: block;
 }
`;

const Forms = (props) => {
  return (
    <FormsWrapper
      {...props}
    >
      {props.children}
    </FormsWrapper>
  );
};

export default Forms;
